<template>
  <div
    class="notification-content"
    :class="{'not-viewed': !notificationsItem.viewed}">
    <div class="flex flex-between">
      <div
        class="notification-name-wrapper">
        <NotificationCardAuthor
          mode="modal"
          :value="notificationsItem"/>
        <div class="ml-3 notification-type">
          {{ $t(`Notifications.NotificationType.${notificationsItem.messageType}`) }}
        </div>
        <div>
          <div
            v-if="statusChipFrom || statusChipTo || dateFrom || dateTo || statusComment.length"
            class="flex ml-4 align-center flex-wrap">
            <div v-if="statusChipFrom || dateFrom">
              <span>{{ $t('Common.From') }}</span>
              <StatusChip
                v-if="statusChipFrom"
                class="font-size-11 mx-5 chip"
                :data-qa="`history-status-${notificationsItem.StatusFrom}`"
                key-name="id"
                :status="statusChipFrom"
                value-name="title"/>
              <span
                v-if="dateFrom"
                class="ml-1">{{ dateFrom }}</span>
            </div>
            <div v-if="statusChipTo || dateTo">
              <span :class="{'ml-1': !!dateFrom}">
                {{ $t('Common.To') }}
              </span>
              <StatusChip
                v-if="statusChipTo"
                class="font-size-11 mx-5 chip"
                :data-qa="`history-status-${notificationsItem.StatusTo}`"
                key-name="id"
                :status="statusChipTo"
                value-name="title"/>
              <span
                v-if="dateTo"
                class="ml-1">{{ dateTo }}</span>
            </div>
            <div v-if="statusComment.length">
              {{ statusComment }}
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-right">
        <div
          class="font-size-12 black--text text--secondary pb-0 my-auto">
          {{ notificationsItem.entity.dateSend }}
        </div>
        <sButton
          class="pa-0"
          color="var(--black-color)"
          :disabled="notificationsItem.viewed"
          :icon="notificationsItem.viewed ? 'mail-open' : 'mail'"
          icon-size="18px"
          small
          type="text"
          @click.prevent.stop="changeViewed"/>
      </div>
    </div>
    <div
      v-if="comment"
      class="inner-chat-card_message ml-10">
      <div class="inner-chat-card_message-item">
        <div v-if="comment.length">
          {{ comment }}
        </div>
        <template
          v-else>
          <InnerChatMessage
            v-if="tag.message"
            :value="tag"
            @clickTag="$_clickTag"/>
          <template v-if="attachmentsLength">
            <div
              class="width-100 flex"
              :class="{'mt-2': !!tag.message}">
              <sIcon
                class="my-auto"
                size="14"
                type="draft"/>
              <span class="ml-1 my-auto">{{ decodeURI(tag.attachments[0].fileName) }}</span>
            </div>
            <div
              v-if="attachmentsLength > 1"
              class="width-100 flex">
              <sIcon
                class="my-auto"
                size="14"
                type="draft"/>
              <span class="ml-1 my-auto">{{ decodeURI(tag.attachments[1].fileName) }}</span>
            </div>
            <div
              v-if="attachmentsLength>2"
              class="width-100 flex">
              <sIcon
                class="my-auto"
                size="14"
                type="draft"/>
              <span class="ml-1 my-auto">
                ...{{ $t('Purchasing.More') }}: {{ attachmentsLength - 2 }}</span>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import StatusChip from 'components/common/elements/StatusChip.vue'
import InnerChatMessage from 'components/common/blocks/inner-chat/InnerChatMessage.vue'
import NotificationCardAuthor from 'components/common/blocks/notification/NotificationCardAuthor.vue'
import moment from 'moment'
import { innerChatMixin} from 'mixins'
import notifications from 'mixins/notifications'

export default {
  name: 'notificationsGroupCardContentItem',
  mixins: [innerChatMixin, notifications],
  data() {
    return {
      statusChipFrom: null,
      statusChipTo: null,
      dateFrom: null,
      dateTo: null,
      statusComment: '',
      comment: null,
    }
  },
  computed: {
    attachmentsLength() {
      if (!this.tag?.attachments?.length) {
        return 0
      }
      return this.tag?.attachments?.length
    },
    tag() {
      if (this.notificationsItem.Tags) {
        return {
          message: this.notificationsItem.Comment,
          tags: [...JSON.parse(this.notificationsItem.Tags)],
          attachments: this.notificationsItem.Attachments ? JSON.parse(this.notificationsItem.Attachments) : []
        }
      } else {
        return {message: this.notificationsItem.Comment, tags: []}
      }
    },

  },
  methods: {
    changeViewed() {
      this.$_changeViewedMessages([this.notificationsItem])
    },
    getMessageToConent() {
      switch (this.notificationsItem.messageType) {
      case 'AddTenderBid':
        this.comment = ''
        break
      case 'ChangeTenderAgreeStatus':
        if (this.notificationsItem.properties.find(i => i.key === 'AgreementStatus')?.value === 'Success') {
          this.statusChipTo = {
            id: 10,
            title: this.$t('Common.Approved')
          }
        } else {
          this.statusChipTo = {
            id: 11,
            title: this.$t('Application.Decline')
          }
        }
        break
      case 'AddInnerChatTenderMessage':
      case 'InnerChat':
      case 'InnerChatAnswerMe':
      case 'AddTenderComment':
        this.comment = Object.freeze(this.notificationsItem)
        break
      case 'ChangeTenderStatus':
        if (this.notificationsItem.StatusFrom) {
          this.statusChipFrom = this.statusObject(this.notificationsItem.StatusFrom, this.statuses)
        }
        if (this.notificationsItem.StatusTo) {
          this.statusChipTo = this.statusObject(this.notificationsItem.StatusTo, this.statuses)
        }
        break
      case 'UnselectTenderBid':
        this.statusComment = this.$t('Common.Within30Days')
        break
      case 'CancelTenderBid':
        this.statusComment = ''
        break
      case 'ProlongateTender':
        this.dateTo = this.formatDateTime(this.notificationsItem.ProlongationTo)
        this.dateFrom = this.formatDateTime(this.notificationsItem.ProlongationFrom)
        break
      case 'ChangeTenderWinner':
        this.comment = this.notificationsItem.Reason
        break
      case 'AwatingTenderConfirmation':
        this.statusComment = this.$t('Notifications.NotificationType.AwatingTenderConfirmation')
        break
      case 'AgreementAssigned':
        this.comment = this.$t('Common.YouHaveSddedToApprover')
        break
      case 'ChangeTenderApprovalStatus':
        this.statusComment = ''
        break
      }
    },
    statusObject(stat, spr) {
      let st = ''
      st = spr?.find(status => status.statusCode == stat)
      if (st) {
        return {
          id: +stat,
          title: st.title,
        }
      }
      return stat
    },
    formatDateTime(value) {
      if (value) {
        return moment(value).format('DD.MM.YYYY HH:mm ')
      } else {
        return '–'
      }
    }
  },
  props: {
    notificationsItem: {
      type: Object
    },
    statuses: Array
  },
  async created() {
    this.getMessageToConent()
  },
  components: {
    StatusChip,
    InnerChatMessage,
    NotificationCardAuthor
  }
}
</script>
<style scoped lang="scss">
.v-chip.v-size--small{
  height: 22px!important;
  margin-bottom:3px;
}
.notification-content{
    border-bottom:1px solid var(--color-main-green);
    padding: 14px 10px 14px 20px;

    &.not-viewed {
      position: relative;
      &::before {
        content: "";
        display: block;
        background: var(--color-main-green);
        width: 8px;
        height: 8px;
        position: absolute;
        left: 0px;
        top: 0px;
        border-radius: 0 0 50px 0;
      }
    }

    &:last-child{
        border:none;
    }
}
.notification-type {
  margin: auto 0 auto 5px;
  border-radius: 50px;
  color: var(--v-secondary__green_not_active-base);
  padding: 4px 8px;
  text-align: center;
  border: 1px solid var(--v-secondary__green_not_active-base);
  width: max-content;
  font-weight: 500;
  font-size: 11px;
  line-height: 12px;
}
.notification-name-wrapper {
  display: flex;
  align-items: center;
  &__author{
    font-size:14px;
  }
}
</style>

<style lang="scss">
.inner-chat-card_tag {
  font-weight: bold;
  &-0 {
    font-weight: 600;
    text-decoration: underline;
  }
  &-1 {
    text-decoration: underline;
  }
  &-2 {
    text-decoration: underline;
  }
}
</style>
<style scoped lang="scss">
.inner-chat-card {
  margin: 10px auto 0;
  text-align: left;
  max-width: 830px;
  width: 100%;
  border-radius: 20px 5px 18px 18px;
  &_header {
    display: flex;
  }
  &_userLogin {
    padding-left: 8px;
    color: var(--black-color);
    font-size: 14px;
    line-height: 18px;
  }
  &_time {
    padding-left: 8px;
    color: var(--black-color);
    opacity: 0.5;
    font-size: 12px;
    line-height: 16px;
  }
  &_tag {
    font-weight: bold;
    &-0 {
      color: blue;
    }
    &-1 {
      color: red;
    }
    &-2 {
      color: green;
    }
  }
  &_message {
    position: relative;
    margin-top: 8px;
    margin-left: 15px;
    padding: 20px;
    color: var(--black-color);
    background: var(--green_chosen_light);
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    border-radius: 0 15px 15px 15px;
    &:hover,
    &:focus {
      .inner-chat-card_message-btn-answer {
        opacity: 1;
      }
    }
    &-item {
      align-self: flex-start;
      display: flex;
      justify-content: space-between;
      white-space: pre-line;
      overflow: auto;
      text-align: left;
      flex-wrap: wrap;
    }
    &-parent {
      border-left: 2px solid #080808;
      cursor: pointer;
      padding-left: 6px;
      color: #828e8d;
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 10px;
    }
    &-btn-answer {
      opacity: 0;
      transition: 0.25s all;
      align-self: flex-end;
    }
    &-is-viewed {
      position: absolute;
      right: 0;
      top: 0;
      width: 14px;
      height: 14px;
      z-index: 1;
      cursor: pointer;
      &::after {
        content: "✓";
      }
      &.true {
        cursor: default;
      }
      &.true::after {
        color: var(--color-main-green);
      }
      &.true::before {
        content: "✓";
        color: var(--color-main-green);
        top: 1px;
        right: 5px;
        position: absolute;
      }
      &.false::after {
        color: grey;
      }
    }
  }
}

.inner-chat-card.mode-modal {
  .inner-chat-card_message {
    margin-left: 0px;
  }
}

.inner-chat-card.is-my {
  border-radius: 5px 20px 18px 18px;
  &.mode-modal {
    .inner-chat-card_message {
      margin-right: 0px;
    }
  }
  .inner-chat-card {
    &_userLogin {
      padding-left: 0px;
      padding-right: 8px;
    }
    &_time {
      padding-left: 0px;
      padding-right: 8px;
    }
  }
  .inner-chat-card_header {
    justify-content: flex-end;
    &-user {
      order: 2;
    }
    &-info {
      order: 1;
    }
  }
  .inner-chat-card_message {
    margin-left: 0px;
    margin-right: 15px;
    border-radius: 15px 0 15px 15px;
    background: var(--color-main-green);
    overflow: hidden;
    &-is-viewed {
      &.true::after {
        color: var(--green_chosen_light);
      }
      &.true::before {
        color: var(--green_chosen_light);
      }
    }
  }
}
</style>
